import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  OrganizationListRequest,
  OrganizationListResponse,
  Organization,
  OrganizationUpdateRequest,
  OrganizationCreateRequest,
  OrganizationListShortRequest,
  OrganizationListShortResponse,
} from "./types";

/**
 * Organization's list service
 */
export const organizationListService = (params?: OrganizationListRequest) =>
  RestAPIClient.call<OrganizationListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Organization's list short service
 */
export const organizationListShortService = (
  params?: OrganizationListShortRequest
) =>
  RestAPIClient.call<OrganizationListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params: {
        ...params,
        tenantId: -1,
      },
    },
  });

/**
 * Organization's Detail service
 */
export const organizationDetailService = (id?: number) =>
  RestAPIClient.call<Organization>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id ?? ""}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Organization's Update service
 */
export const organizationUpdateService = (data: OrganizationUpdateRequest) =>
  RestAPIClient.call<Organization>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id ?? ""}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Organization's Create service
 */
export const organizationCreateService = (data: OrganizationCreateRequest) =>
  RestAPIClient.call<Organization>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update status
 */
export const organizationUpdateStatusService = ({
  id,
  isActive,
}: {
  id: number;
  isActive: boolean;
}) =>
  RestAPIClient.call<Organization>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${id}/${isActive ? "active" : "inactive"}`,
    config: {
      requireAuthentication: true,
    },
  });
